import _ from "lodash"

export const toFlatten = (value: string): string => _.deburr(value).toLowerCase()

export const searchWords = (value: string): string[] =>
  _.compact(toFlatten(value).replace(/ /g, " ").split(" "))
